import { PayloadAction } from '@reduxjs/toolkit';
import { EventBusReceiveMessage } from 'features/application/types';
import { onSDKConnectedSaga } from 'features/sdk/onSDKConnectedSaga';
import { reportCommandFailureSaga } from 'features/sdk/reportCommandFailureSaga';
import { call } from 'redux-saga/effects';

export function* sdkConnectCommandSaga(action: PayloadAction<EventBusReceiveMessage>) {
  try {
    yield call(onSDKConnectedSaga, action.payload.data);
  } catch (error) {
    yield call(reportCommandFailureSaga, error, 'connect');
  }
}
